<template>
  <div class="full-page error-page">
    <van-empty image="error" description="404 Not Found" />
  </div>
</template>

<script>
import { Empty } from 'vant';
export default {
  components: {
    [Empty.name]: Empty
  }
}
</script>
<style lang="less" scoped>
.error-page{
  background-color:white;
}
</style>